export function thankYouConfetti() {
    const page = document.querySelector('[data-thank-you-confetti]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!page || reducedMotion.matches || page.dataset.confettiStarted) return;

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context) return;

    page.dataset.confettiStarted = 'true';
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:1002;';
    document.body.appendChild(canvas);

    const styles = getComputedStyle(document.documentElement);
    const colors = [
        styles.getPropertyValue('--color-background-primary').trim() || '#00616f',
        styles.getPropertyValue('--color-background-accent').trim() || '#00998c',
        styles.getPropertyValue('--color-background-highlight').trim() || '#ffdd00',
        '#ffffff',
    ];
    const duration = 5000;
    let width;
    let height;
    let frame;

    function resize() {
        width = window.innerWidth;
        height = window.innerHeight;
        const pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.round(width * pixelRatio);
        canvas.height = Math.round(height * pixelRatio);
        context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    }

    resize();

    const particles = Array.from({ length: width < 768 ? 150 : 260 }, () => ({
        x: Math.random(),
        y: -Math.random(),
        speed: 0.3 + Math.random() * 0.25,
        size: 8 + Math.random() * 10,
        angle: Math.random() * Math.PI * 2,
        spin: (Math.random() - 0.5) * 6,
        sway: Math.random() * Math.PI * 2,
        color: colors[Math.floor(Math.random() * colors.length)],
    }));
    const startedAt = performance.now();

    function cleanup() {
        cancelAnimationFrame(frame);
        canvas.remove();
        window.removeEventListener('resize', resize);
        window.removeEventListener('pagehide', cleanup);
        reducedMotion.removeEventListener('change', onMotionChange);
    }

    function onMotionChange(event) {
        if (event.matches) cleanup();
    }

    function draw(now) {
        const elapsed = now - startedAt;
        if (elapsed >= duration) {
            cleanup();
            return;
        }

        const seconds = elapsed / 1000;
        context.clearRect(0, 0, width, height);
        context.globalAlpha = Math.min(1, (duration - elapsed) / 1000);

        particles.forEach((particle) => {
            const x = particle.x * width + Math.sin(seconds * 2 + particle.sway) * 35;
            const y = (particle.y + seconds * particle.speed) * height;
            context.save();
            context.translate(x, y);
            context.rotate(particle.angle + seconds * particle.spin);
            context.scale(1, Math.cos(seconds * 5 + particle.sway));
            context.fillStyle = particle.color;
            context.fillRect(-particle.size / 2, -particle.size / 4, particle.size, particle.size / 2);
            context.restore();
        });

        frame = requestAnimationFrame(draw);
    }

    window.addEventListener('resize', resize);
    window.addEventListener('pagehide', cleanup);
    reducedMotion.addEventListener('change', onMotionChange);
    frame = requestAnimationFrame(draw);
}
